import { getRequest } from '../../../Services/HttpService';
import PermissionsService, {
  PERMISSION_ONLINE_MAP_TEMPLATES_ASSIGN,
  PERMISSION_ONLINE_MAP_TEMPLATES_CUSTOMER,
  PERMISSION_ONLINE_MAP_TEMPLATES_PRIVATE,
} from '../../../Services/PermissionsService';
import { getCustomerId } from '../../../Services/UserService';
import { IVehicleOnlinePanelState, IVehicleOnlinePanels } from '../../OnlinePanel/OnlinePanelState';
import { IVehicleGdprDataAllowed, IVehicles, IVehiclesData } from '../../Vehicles/types';
import { IOnlinePanelData, IOnlinePanelDataForWidgets } from './types';

const SYSTEM_TEMPLATE = 'system';

export const getWidgetData = async (
  vehicleId: number
): Promise<IOnlinePanelDataForWidgets | false> => {
  const response = await getRequest<IOnlinePanelDataForWidgets>(
    `/v1/vehicle/${vehicleId}/online-panel/widget`
  );
  return response as IOnlinePanelDataForWidgets | false;
};

export const canEditOnlineTemplate = (panelData: IOnlinePanelData | null): boolean => {
  if (
    PermissionsService.hasAccess(PERMISSION_ONLINE_MAP_TEMPLATES_CUSTOMER, ['update']) === true &&
    panelData &&
    panelData.type === SYSTEM_TEMPLATE
  ) {
    return true;
  }
  if (
    (PermissionsService.hasAccess(
      PERMISSION_ONLINE_MAP_TEMPLATES_CUSTOMER,
      ['read', 'create'],
      getCustomerId()
    ) === true ||
      PermissionsService.hasAccess(
        PERMISSION_ONLINE_MAP_TEMPLATES_PRIVATE,
        ['read', 'create'],
        getCustomerId()
      ) === true ||
      PermissionsService.hasAccess(
        PERMISSION_ONLINE_MAP_TEMPLATES_ASSIGN,
        ['read', 'create'],
        getCustomerId()
      ) === true) &&
    panelData &&
    panelData.type !== SYSTEM_TEMPLATE
  ) {
    return true;
  }
  return false;
};

export const getExtraDataForWidgets = async (vehicleId: number | false) => {
  if (!vehicleId) {
    return false;
  }

  const dataForWidgets = await getWidgetData(vehicleId);

  if (Array.isArray(dataForWidgets) && dataForWidgets.length === 0) {
    return false;
  }

  return dataForWidgets || false;
};

export const getGdprPermission = (
  onlinePanelVehiclesData: IVehicleOnlinePanels,
  vehicleId: number | false,
  vehicles: IVehicles,
  isVehicleGdprDataAllowed: IVehicleGdprDataAllowed,
  vehiclesData: IVehiclesData
) => {
  if (onlinePanelVehiclesData && vehicleId && Number.isInteger(vehicleId)) {
    const car: IVehicleOnlinePanelState = onlinePanelVehiclesData[vehicleId];

    if (car && vehicles[vehicleId].drivingMode === 'private') {
      if (vehicleId && Number.isInteger(vehicleId) && isVehicleGdprDataAllowed) {
        return isVehicleGdprDataAllowed[vehicleId];
      }
      return false;
    }
    if (car && vehicles[vehicleId].drivingMode === 'business') {
      return true;
    }

    // Toto je tu naco? Ak existuje vozidlo a ma status UNKNOWN, tak sa nema zobrazovat online panel
    // Aky je dovod na toto dovod aby to potom vracalo true?
    // Zakomentovavam.
    // Okrem toho funkcia, ktorou zistijem ci sa ma zobrazit online panel v renderi nema co setovat state.
    //
    // If vehicle has nullable vehicle status (aka is newly created and whitout any ride) show online panel
    // if (vehiclesData[vehicleId] && vehiclesData[vehicleId].status === 'UNKNOWN') {
    //   setIsOnlinePanelOpen(false);
    //   return true;
    // }

    return isVehicleGdprDataAllowed[vehicleId];
  }
  return true;
};
